function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckResetPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48pt",
    height: "48pt",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 21.703125 34.113281 L 10.894531 23.3125 L 14.117188 20.097656 L 21.695312 27.675781 L 41.007812 8.371094 C 36.539062 3.757812 30.421875 1.113281 24 1.015625 C 11.308594 1.015625 1.015625 11.308594 1.019531 24 C 1.019531 36.695312 11.308594 46.984375 24.003906 46.980469 C 36.695312 46.980469 46.984375 36.691406 46.984375 24 C 47.011719 19.871094 45.898438 15.8125 43.765625 12.277344 Z M 21.703125 34.113281 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckResetPassword);
export default __webpack_public_path__ + "static/media/Check_reset_password.9c45f274e333ddb9125ab1718e1c1d48.svg";
export { ForwardRef as ReactComponent };